import React,{useState,useEffect} from 'react'
import {auth,provider} from "../firebase-config.js"
import {signInWithPopup} from "firebase/auth"
import Cookies from "universal-cookie"
import { Navigate } from 'react-router-dom'
import Home from './Home.js'
import {Card} from "antd"
const Auth = (props) => {
  const {setAuth,isAuth} = props
    const cookies = new Cookies(); 
   const [data,setUserdata] = useState(null);
    const signIn =async()=>{
   const result = await signInWithPopup(auth,provider);
   console.log(result);
   cookies.set("auth-token",result.user.refreshToken);
 
   setUserdata(result.photoURL);
   setAuth(true);

    } 
  



    if(isAuth){ return <Home data={data} ></Home>}


  return (

    <Card 
    style={{display:"flex",justifyContent:"center",flexDirection:"column",gap:"20px"}}
    > 
        
    <div className='auth'><p> Sign in with Google</p>
    {isAuth ? "Signing in":""}
    <button onClick={signIn}>Sign in with Google </button>
   

        
    
    </div>
    </Card>
)}

export default Auth